import React, { useState, useEffect } from 'react';
import { bool, string, func, array } from 'prop-types';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import EntidadesMultipleModal from '../../controls/EntidadesMultipleModal';

import './index.css'


const InputEntidadMultiple = (props) => {

    const [state, setState] = useState({
        values: [],
        showList: false
    });

    const [getListEntidad, getRowEntidad, readyEntidad] = useEntidad({
        entidades: props.data ? [] : [props.entidad],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: (props.memo) ? {
          key: props.entidad,
          timeout: 0
        }: null
    });

    useEffect(() => {
        const values = Array.isArray(props.values) ? props.values : (props.values ? [props.values] : []);
        setState(prevState => {
            return {...prevState, values };
        });
    }, [props.values, readyEntidad]);

    const onConfirm = (selectedItems) => {
        const ids = selectedItems.map(item => item.id);
        if (props.onChange) {
            props.onChange({
                target: {
                    name: props.name,
                    type: 'entidadMultiple',
                    value: ids,
                    rows: selectedItems
                }
            });
        }
        setState(prevState => {
            return {...prevState, showList: false};
        });
    }

    const onClear = (e) => {
        e.stopPropagation();
        if (props.onChange) {
            props.onChange({
                target: {
                    name: props.name,
                    type: 'entidadMultiple',
                    value: [],
                    rows: []
                }
            });
        }
    }

    function getListEntidadProxy() {
        if (props.data) {
            return props.data;
        }
        else {
            return getListEntidad(props.entidad) || [];
        }
    }

    function getRowEntidadProxy(id) {
        if (props.data) {
            return props.data.find(f => f.id === id);
        }
        else {
            return getRowEntidad(props.entidad, id);
        }
    }

    function getDisplayText() {
        const values = state.values || [];
        if (values.length === 0) {
            return '';
        }
        if (values.length === 1) {
            const row = getRowEntidadProxy(values[0]);
            return props.onFormat(row ?? '');
        }
        return `${values.length} Seleccionados`;
    }

    const displayText = getDisplayText();
    const hasValues = (state.values?.length || 0) > 0;

    return (
        <div className='input-entidad-multiple-wrapper'>

            {state.showList && (
                <EntidadesMultipleModal
                    title={props.title}
                    tipName={props.tipName}
                    entidad={props.entidad}
                    onDismiss={() => {
                        setState(prevState => {
                            return {...prevState, showList: false};
                        });
                    }}
                    onConfirm={onConfirm}
                    filter={props.filter}
                    columns={props.columns}
                    data={getListEntidadProxy()}
                    selectedIds={state.values || []}
                    memo={props.memo}
                    selectionLabelAccessor={props.selectionLabelAccessor}
                />
            )}

            <input
                name={props.name}
                type="text"
                placeholder={props.placeholder}
                className={`input-entidad-multiple ${props.className}`}
                value={displayText}
                onClick={() => {
                    if (!props.disabled) {
                        setState(prevState => {
                            return {...prevState, showList: true};
                        });
                    }
                }}
                onKeyDown={(e) => { if (e.key === 'Enter' && !props.disabled) setState(prevState => ({...prevState, showList: true})); }}
                readOnly={true}
                disabled={props.disabled}
            />

            {!props.disabled && hasValues && (
                <span
                    className="material-symbols-outlined input-entidad-multiple-clear"
                    onClick={onClear}
                >close</span>
            )}
        </div>
    )
}

InputEntidadMultiple.propTypes = {
    title: string,
    entidad: string.isRequired,
    name: string.isRequired,
    placeholder: string,
    className: string,
    values: array,
    onChange: func,
    onFormat: func,
    filter: func,
    columns: array,
    data: array,
    disabled: bool,
    memo: bool,
    tipName: string,
    selectionLabelAccessor: func
};

InputEntidadMultiple.defaultProps = {
    title: "",
    placeholder: "Seleccionar",
    className: "",
    values: [],
    onChange: null,
    onFormat: (row) => (row && row.id) ? `${row.codigo} - ${row.nombre ?? row.descripcion}` : '',
    filter: (row) => { return true },
    columns: [
        { Header: 'Código', accessor: 'codigo', width: '25%' },
        { Header: 'Nombre', accessor: 'nombre', width: '70%' }
    ],
    data: null,
    disabled: false,
    memo: true,
    tipName: '',
    selectionLabelAccessor: (item) => `${item.codigo} - ${item.nombre ?? item.descripcion}`
};

export default InputEntidadMultiple;
